import React, { FC } from 'react'
import classNames from 'classnames'
import { useSelector } from 'react-redux'
import { RootState } from '../../../states/containers/store'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { setPath, setUrlParam } from '../../../utils/url'
import { URL } from '../../constants/url'
import { Link, useParams } from 'react-router-dom'
import { isAdministrator } from '../../../utils/role'
import ANALYZE_REPORT from '../../constants/analyzeReport'
import { IconName } from '@fortawesome/fontawesome-common-types'

type LangValue = 'ja' | 'en'

interface Props {
  isOpen: boolean
  toggleCallback: VoidFunction
}

const SideBarSub: FC<Props> = (props) => {
  const {
    isOpen,
    toggleCallback,
  } = props

  const {
    login,
  } = useSelector((state: RootState) => state)

  const { language } = useParams<{ language: LangValue }>()

  return (
    <>
      {
        (location.pathname.match(URL.ANALYZE.path) || location.pathname.match(URL.EXPORT.path))
        && login.feature_config?.organizational_analysis_view
          ? (
            <div className="side_sub_wrap">
              <div className="tools">
                <div className="calendar_text">
                  <div />
                  <button
                    type="button"
                    className={`menu_toggle ${isOpen && "display"}`}
                    onClick={() => toggleCallback()}
                  >
                    <div className={`menu ${isOpen && "active"}`}>
                      <FontAwesomeIcon icon={['fas', 'angle-double-left']} />
                    </div>
                  </button>
                </div>
              </div>
              <section className="side_sub">
                <div>
                  <div className="item folder">
                    <div className="name_label">
                      <div className="name_area">
                        分析レポート
                      </div>
                    </div>
                  </div>
                  <Link
                    to={setPath(URL.APP_ANALYZE.path, language)}
                    className={classNames({
                      active: location.pathname.match(URL.APP_ANALYZE.path),
                      item: true,
                      indent_1: true,
                    })}
                  >
                    <div className="name_label">
                      <div className="name_area">
                        <FontAwesomeIcon
                          icon={['fas', 'file-alt']}
                          className="icon task"
                        />
                        アプリケーション分析
                      </div>
                    </div>
                  </Link>
                  {
                    ANALYZE_REPORT.map((value) => (
                      <React.Fragment key={`side_sub_${value.key}`}>
                        <Link
                          to={setPath(setUrlParam(
                            URL.ANALYZE_REPORT_DETAIL.path,
                            [
                              { key: 'type', value: value.key },
                            ],
                          ), language)}
                          className={classNames({
                            active: location.pathname.match(setUrlParam(
                              URL.ANALYZE_REPORT_DETAIL.path,
                              [
                                { key: 'type', value: value.key },
                              ],
                            )),
                            item: true,
                            indent_1: true,
                          })}
                        >
                          <div className="name_label">
                            <div className="name_area">
                              <FontAwesomeIcon
                                icon={['fas', value.fontIcon as IconName]}
                                className="icon task"
                              />
                              {value.title}
                            </div>
                          </div>
                        </Link>
                      </React.Fragment>
                    ))
                  }
                </div>
                <div style={{ margin: "0 8px" }}>
                  <div>
                    <div className="item folder no_border">
                      <div className="name_label">
                        <div
                          className="name_area"
                          style={{
                            backgroundColor: "#4d6eae",
                            padding: "8px 12px",
                            marginLeft: "-16px",
                            marginBottom: "-2px",
                            borderRadius: "4px 4px 0 0",
                          }}
                        >
                          操作
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      backgroundColor: "#4D6EAE",
                      borderRadius: "0 8px 8px 8px",
                    }}
                  >
                    <Link
                      to={setPath(URL.EXPORT.path, language)}
                      className={classNames({
                        active: location.pathname.match(URL.EXPORT.path) && location.pathname.split("/").length === 3,
                        item: true,
                      })}
                    >
                      <div className="name_label">
                        <div className="name_area">
                          <FontAwesomeIcon
                            icon={['fas', 'file-download']}
                            className="icon task"
                          />
                          データエクスポート
                        </div>
                      </div>
                    </Link>
                    <Link
                      to={setPath(URL.ANALYZE_SEARCH.path, language)}
                      className={classNames({
                        active: location.pathname.match(URL.ANALYZE_SEARCH.path),
                        item: true,
                        no_border: true,
                      })}
                    >
                      <div className="name_label">
                        <div className="name_area">
                          <FontAwesomeIcon
                            icon={['fas', 'search']}
                            className="icon task"
                          />
                          検索
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>
              </section>
            </div>
          ) : (
            <>
            </>
          )
      }
    </>
  )
}

export default SideBarSub
